import {createFilter} from "v-mask/src/filter";

export const AbcMaskFilter = createFilter;
